import { useState, useEffect, useRef } from "react";
import "@/App.css";
import VideoCompareApp from "./components/VideoCompareApp";
import AuthPage from "./components/AuthPage";
import AnalyticsDashboard from "./components/AnalyticsDashboard";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { supabase } from "./lib/supabaseClient";
import { Toaster } from "sonner";

const toasterProps = {
  position: "top-center",
  theme: "dark",
  toastOptions: {
    style: {
      background: "#1A1A1A",
      border: "1px solid rgba(255,255,255,0.1)",
      color: "#fff",
      fontFamily: "Manrope, sans-serif",
    },
  },
};

function AppContent() {
  const { session } = useAuth();
  const [showAnalytics, setShowAnalytics] = useState(false);
  const tracked = useRef(false);

  // Track one pageview per page load (not per re-render)
  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    const deviceType =
      window.innerWidth < 768 ? "mobile" :
      window.innerWidth < 1024 ? "tablet" : "desktop";
    supabase.from("pageviews").insert({
      referrer: document.referrer || null,
      device_type: deviceType,
      screen_width: window.innerWidth,
    });
  }, []);

  // Still loading session from Supabase
  if (session === undefined) {
    return (
      <div className="h-dvh w-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-6 h-6 rounded-full border-2 border-white/20 border-t-white animate-spin" />
      </div>
    );
  }

  if (showAnalytics && session) {
    return <AnalyticsDashboard onBack={() => setShowAnalytics(false)} />;
  }

  if (!session) return <AuthPage />;

  return <VideoCompareApp onShowAnalytics={() => setShowAnalytics(true)} />;
}

function App() {
  return (
    <AuthProvider>
      <div className="App" data-testid="app-root">
        <AppContent />
        <Toaster {...toasterProps} />
      </div>
    </AuthProvider>
  );
}

export default App;
